<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/active/list" color="orange">返回上一頁</v-btn>&nbsp;&nbsp;&nbsp;

    </div>

    <div class="row">

        <div class="col-1">
            <v-btn @click="createSerialNumber()" color="blue">產出序號</v-btn>
        </div>
        <div class="col-3 col-md-2 py-0">
            <v-text-field
                v-model="serialNumberCount"
                :persistent-hint="true"
                label="序號數量"
                outlined
            ></v-text-field>
        </div>


        <div class="col-1"></div>


        <div class="col-1">
            <v-btn @click="importSerialNumber()" color="green">匯入序號</v-btn>
        </div>
        <div class="col-3 col-md-2 py-0">
            <v-file-input
                name="csvfile"
                id="csvfile"
                accept=".csv"
                label="csv匯入"
                outlined
            ></v-file-input>
        </div>
        <div class="col-2">
            範例檔案
        </div>
    </div>

    <v-data-table :headers="thead" :items="serialNumberList" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.is_used="{ item }">
        <template v-if="item.is_used">
          <font color="green">已核銷</font>
        </template>
        <template v-else>
          <font color="red">未核銷</font>
        </template>
      </template>


      <template v-slot:item.delete="{ item }">

        <v-btn @click="deleteRow(item.id)" color="red">刪除</v-btn>
        <!-- <v-btn @click="deleteRow(item.active_id)" outlined color="red" >刪除</v-btn> -->
      </template>

    </v-data-table>
    <Confirm @confirm="deleteConfirm" :dialog="dialog" title="是否確認刪除？" text />
  </v-flex>

</template>



<script>
import { mapState, mapActions } from "vuex";

import activesApi from "@/api/actives";
import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: [],
  data() {
    return {
      id: 0,
      dialog: false,
      valid: false,
      delete_id: null,
      //activeInfo: {},
      serialNumberList: [],
      serialNumberCount: 0,
      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "序號號碼",
          value: "serial_no"
        },
        {
          text: "是否已核銷",
          value: "is_used"
        },
        {
          text: "核銷機器",
          value: "machine_name"
        },
        {
          text: "核銷時間",
          value: "used_time"
        },
        {
          text: "刪除",
          value: "delete"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {
    // resHandling(res) {
    //   this.activeInfo = JSON.parse(JSON.stringify(res.data));
    // },
    getSerialNumber(){
        activesApi
          .getSerialNumberListByID(this.id)
          .then(res => {
            this.serialNumberList = res.data;
            this.serialNumberCount = res.data.length;

            this.serialNumberList.forEach((item, idx) => {
              item.no = idx + 1;
            });
          })
          .catch(err => {});
    },
    createSerialNumber() {
        //
        activesApi
          .createSerialNumberByID(this.id, {
              numbers: this.serialNumberCount
            })
          .then(res => {
            this.getSerialNumber();
          })
          .catch(err => {});
    },
    importSerialNumber(){
        let fileInput = $('#csvfile');
        console.log(fileInput)

        if(fileInput[0].files.length <= 0){
            console.log('xxx')
        }
        else{
            var request_data = new FormData();
            request_data.append('csvfile', fileInput[0].files[0]);

            activesApi
              .importSerialNumberByID(this.id, request_data)
              .then(res => {
                this.getSerialNumber();
              })
              .catch(err => {});
        }
    },
    deleteRow(val) {
      this.dialog = true
      this.delete_id = val;
    },
    deleteConfirm(result) {
      this.dialog = false;

      if (result) {
        activesApi
          .deleteSerialNumberByID(this.id, this.delete_id)
          .then(res => {
            this.getSerialNumber();
          })
          .catch(err => {});

      }
    },
  },

  mounted() {

    this.id = Number(this.$route.params.id);

    activesApi
      .getByID(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});


    this.getSerialNumber();
  }
};
</script>

<style lang="scss" scoped>
</style>
